import { crmWSApiRequest } from '@/api/external/crmWSApiRequest';
import { getPartnerBySlug } from '@/api/partners/getPartnerBySlug';
import { extractPartnerName } from '@/lib/extractPartnerName';
import type { IPartner } from '@/types';

type IPartnerCRMData = Pick<
  IPartner,
  | 'AllowWhiteLabel'
  | 'LogoFile'
  | 'PrimaryColor'
  | 'SecondaryColor'
  | 'TertiaryColor'
  | 'PrimaryTextColor'
  | 'SecondaryTextColor'
  | 'StoreUrl'
  | 'StorePhone'
  | 'StoreEmail'
  | 'MarketplaceName'
  | 'MarketplaceDesc'
  | 'TermsOfService'
  | 'PrivacyPolicy'
> & { ProfileID: string };

export function currentPartnerQuery(url: string) {
  const slug = extractPartnerName(url);

  return {
    queryKey: ['current-partner', slug],
    queryFn: async () => {
      if (!slug) {
        return null;
      }

      const {
        data: { data: partnerData },
      } = await getPartnerBySlug(slug);
      if (!partnerData) {
        return null;
      }

      const response = await crmWSApiRequest<{
        Results: { Partners: IPartnerCRMData[] };
      }>('partner-list', {
        ProfileID: partnerData.profile_id,
      });

      const partnerCRMData = response.Results.Partners.find(
        (data) =>
          data.ProfileID.toString() === partnerData.profile_id.toString()
      );

      if (!partnerCRMData) {
        return null;
      }

      const partner: IPartner = {
        ...partnerData,
        ...partnerCRMData,
      };
      return partner;
    },
    staleTime: Number.POSITIVE_INFINITY,
  };
}
